import React from 'react'
import PropTypes from 'prop-types'
import moment from '../../../../helpers/moment'

export const ShiftRow = ({ start, activeDrivers, currentShift }) =>
  <tr>
    <td name="start">
      {currentShift && <span className={"fa fa-star mg-r-4"} />}
      {moment(start).format("HH:mm:ss ZZ")}
    </td>
    <td name="activeDrivers">{activeDrivers}</td>
    <td />
  </tr>

ShiftRow.propTypes = {
  start: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  activeDrivers: PropTypes.number.isRequired,
  currentShift: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/containers/pools/details/shifts/shiftRow.js